import React from 'react';
import { mockNominees } from '../../../services/mockData';

const NomineeRegister = () => (
  <div className="fade-in">
    <div className="page-header">
      <div className="breadcrumb">Registers <span>/ Nominee Register</span></div>
      <h2>Nominee Register</h2>
    </div>

    <div className="card">
      <div className="card-header">
        <span className="card-title">Nominee Report</span>
        <button className="btn btn-warning btn-sm">🖨️ Print</button>
      </div>

      <div className="report-header" style={{ marginBottom: '16px' }}>
        <h3>Vitthal Plaza Co-Op Housing Society LTD</h3>
        <p>Registration Number: TNADO(M/HSG/TC)/25796/YEAR-2023 | dr Sagar(Dombivali)</p>
        <p style={{ fontWeight: '700', marginTop: '6px' }}>Nominee Register 2025-2026 On dated: 2026-02-02</p>
      </div>

      <div className="table-wrapper">
        <table>
          <thead>
            <tr>
              <th>Unit No.</th>
              <th>Name of Member Making Nomination</th>
              <th>Date of Nomination</th>
              <th>Name/s of Nominee/s & Address</th>
              <th>Date of Managing Committee Meeting</th>
              <th>Date of Subsequent Revocation</th>
              <th>Remarks</th>
            </tr>
          </thead>
          <tbody>
            {mockNominees.map((n, i) => (
              <tr key={i}>
                <td><span className="badge badge-primary">{n.unitNo}</span></td>
                <td style={{ fontWeight: '600' }}>{n.memberName}</td>
                <td>{n.dateOfNomination}</td>
                <td style={{ fontSize: '12px' }}>{n.nomineeName}</td>
                <td>{n.committeeMeetingDate}</td>
                <td>{n.subsequentRevocation}</td>
                <td style={{ fontSize: '11px', color: '#718096' }}>{n.remarks}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  </div>
);

export default NomineeRegister;
